// Správa tématu s persistencí do localStorage.
// Redesign „Noční kokpit" (2026-08): výchozí je TMAVÁ (řidiči startují ve 3
// ráno), světlý krém se zapíná ručně — data-theme="light" na <html>.
// Starší uložené hodnoty "auto"/"dark" se mapují na tmavou.

import { useSyncExternalStore } from "react";

export type ThemeMode = "dark" | "light";

const STORAGE_KEY = "routera:theme";

let current: ThemeMode = "dark";
const listeners = new Set<() => void>();

function applyTheme(mode: ThemeMode) {
  const root = document.documentElement;
  if (mode === "light") root.setAttribute("data-theme", "light");
  else root.removeAttribute("data-theme");
}

export function setTheme(mode: ThemeMode) {
  current = mode;
  applyTheme(mode);
  localStorage.setItem(STORAGE_KEY, mode);
  listeners.forEach((l) => l());
}

export function toggleTheme() {
  setTheme(current === "light" ? "dark" : "light");
}

export function useTheme(): ThemeMode {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current
  );
}

// Inicializace při startu (před prvním renderem)
export function initTheme() {
  const stored = localStorage.getItem(STORAGE_KEY);
  current = stored === "light" ? "light" : "dark";
  applyTheme(current);
}
